/**
 * A failed run, said in words with the backend's own message one click away
 * (DOP-627). Used on the Tape tab and on the Needs you card.
 */

import React, { useState } from "react";
import type { RunFailure } from "./runFailure";

export interface RunFailureNoteProps {
	failure: RunFailure;
}

const RunFailureNote: React.FC<RunFailureNoteProps> = ({ failure }) => {
	const [open, setOpen] = useState(false);
	return (
		<div className="flex flex-col gap-1.5">
			<p className="text-sm leading-normal">{failure.summary}</p>
			{failure.detail && (
				<>
					<button
						type="button"
						onClick={() => setOpen((value) => !value)}
						aria-expanded={open}
						className="self-start text-xs font-medium underline underline-offset-[3px]"
					>
						{open ? "Hide details" : "Show details"}
					</button>
					{open && (
						<pre className="whitespace-pre-wrap break-words rounded-lg bg-white/70 px-3 py-2 font-mono text-[11.5px] text-[#3f4247]">
							{failure.detail}
						</pre>
					)}
				</>
			)}
		</div>
	);
};

export default RunFailureNote;
